<template>
  <div class="conent">
    <!-- 顶部栏 -->
    <div class="header">
      <div class="header_search">
        <div class="search">
          <div style="width: 40%">
            <!-- 名字搜索 -->
            <span class="flex_around flex_around_input">
              <el-input placeholder="请输入姓名" v-model="Name" clearable> </el-input>
              <el-button type="primary" @click="Query(Name, 'input_names')"
                >姓名查找</el-button
              >
            </span>
            <!-- 身份证号查找 -->
            <span class="flex_around flex_around_input">
              <el-input placeholder="请输入证件号" v-model="IdCard" clearable> </el-input>
              <el-button type="primary" @click="Query(IdCard, 'input_idcards')"
                >证件查找</el-button
              >
            </span>
          </div>

          <div style="width: 40%">
            <!-- 日期查找 -->
            <span class="flex_around flex_around_input">
              <el-date-picker
                v-model="Dates"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"
              >
              </el-date-picker>
              <el-button type="primary" @click="QueryDate(Dates)">日期查找</el-button>
            </span>
            <!-- 种类查找 -->
            <span class="flex_around flex_around_input">
              <el-input
                placeholder="请输入种类名称，如：黄金、铂金"
                v-model="Type"
                clearable
              >
              </el-input>
              <el-button type="primary" @click="Query(Type, 'input_wus')"
                >种类查找</el-button
              >
            </span>
          </div>
        </div>
      </div>
      <div class="header_info">
        <div>
          今日回收 : {{ TodayTotal }}
          <span class="sumTotal"> 金额 : {{ TodayPrice + "元" }} </span>
        </div>

        <div>
          全部回收 : {{ SumTotal }}
          <span class="sumTotal"> 回收金额 : {{ sumPrice + "元" }} </span>
        </div>
      </div>
    </div>

    <!-- 内容栏 -->
    <div class="contents">
      <el-table :data="tableData" height="65vh" border style="width: 100%">
        <el-table-column
          prop="deta"
          label="回收日期"
          width="160"
          header-align="center"
          align="center"
        >
        </el-table-column>

        <el-table-column
          prop="reviewdate"
          label="复核日期"
          width="180"
          header-align="center"
          align="center"
        >
        </el-table-column>

        <el-table-column
          prop="input_pnum"
          label="票号"
          width="160"
          header-align="center"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="input_names"
          label="客户姓名"
          width="150"
          header-align="center"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="tabs_inputs"
          label="物品名称"
          width="150"
          header-align="center"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="tabs_inpus"
          label="物品规格"
          width="150"
          header-align="center"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="input_wus"
          label="物品种类"
          width="150"
          header-align="center"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="tabs_inps"
          label="数量"
          width="150"
          header-align="center"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="tabs_ins"
          label="重量/g"
          width="150"
          header-align="center"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="tabs_is"
          label="金额/元"
          width="150"
          header-align="center"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="hs_ze"
          label="折当率/%"
          width="150"
          header-align="center"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="hpria"
          label="回收单价/元"
          width="150"
          header-align="center"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="agent"
          label="开票"
          width="150"
          header-align="center"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="review"
          label="复核"
          width="150"
          header-align="center"
          align="center"
        >
        </el-table-column>

        <el-table-column fixed="left" label="操作" width="100">
          <template slot-scope="scope">
            <el-button @click="handleClick(scope.row)" type="text" size="small"
              >打票</el-button
            >
            <el-button @click="PrintClick(scope.row)" type="text" size="small"
              >打印告知书</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="pagination">
      业务数量：{{ Total }}
      <!-- 分页 -->
      <el-pagination
        v-if="Showpagination"
        background
        layout="prev, pager, next"
        :page-size="100"
        :total="SumTotal"
        @current-change="Current"
      >
      </el-pagination>

      <span style="margin-left: 10px">
        <download-excel
          class="export-excel-wrapper"
          :data="tableData"
          :fields="json_fields"
          name="回收业务明细表.xls"
        >
          <el-button type="primary" size="small"
            ><i class="el-icon-download"></i>导出Excel</el-button
          >
        </download-excel>
      </span>
    </div>
    <!-- 打票 -->
    <div>
      <el-dialog title="打票" :visible.sync="dialogFormVisible1" width="60%">
        <Printp :xudata="xudata" v-if="dialogFormVisible1" />
      </el-dialog>
    </div>

    <!-- 打印告知书 -->
    <div>
      <el-dialog
        title="打印告知书"
        :visible.sync="PrintTextDiglog"
        width="60%"
        :before-close="PrintTextDiglogClose"
      >
        <PrintDiglog :NewDatas="NewDatas" v-if="PrintTextDiglog" />
      </el-dialog>
    </div>
  </div>
</template>
<script>
import dayjs from "dayjs";
import Printp from "@/components/Printp.vue";
import PrintDiglog from "@/components/printDiglog/PrintDiglog";
export default {
  name: "recycle",
  components: {
    Printp,
    PrintDiglog,
  },
  data() {
    return {
      Name: "",
      Dates: "",
      IdCard: "",
      Type: "",
      SumTotal: 0,
      tableData: [],
      sumPrice: 0,
      date: "",
      TodayTotal: 0,
      TodayPrice: 0,
      Total: 0,
      Showpagination: true,
      dialogFormVisible1: false, //默认不打开打票弹窗
      xudata: {},
      PrintTextDiglog: false,
      NewDatas: {},
      // excel
      json_fields: {
        回收日期: "deta",
        复核日期: "reviewdate",
        票号: "input_pnum",
        姓名: "input_names",
        电话: "input_tels",
        物品名称: "tabs_inputs",
        数量: "tabs_inps",
        "重量/g": "tabs_ins",
        "回收金额/元": "tabs_is",
        "回收单价/元": "hpria",
        "折当率/%": "hs_ze",
        开票: "agent",
        复核: "review",
        财务: "finance",
      },

      json_meta: [
        [
          {
            " key ": " charset ",
            " value ": " utf- 8 ",
          },
        ],
      ],
    };
  },

  methods: {
    //总回收先请求100条
    getData() {
      //先拿到所有的数据总数
      this.axios
        .post("/api/tcb/databasecount?access_token=" + this.ACCESS_TOKEN, {
          env: `${this.userData.env}`,
          query: `db.collection("take_back").count()`,
        })
        .then((res) => {
          let countNum = res.data.count;
          this.SumTotal = res.data.count;

          this.axios
            .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
              env: `${this.userData.env}`,
              query: `db.collection("take_back").where({}).limit(100).skip(${
                countNum - 100
              }).get()`,
            })
            .then((res) => {
              res.data.data.forEach((element, index, array) => {
                array[index] = JSON.parse(element);
              });

              // this.tableData =  res.data.data.sort(function (a,b) {
              //    return b.reviewdate - a.reviewdate;
              //    })

              this.tableData = res.data.data.reverse();
              // this.tableData = res.data.data

              // this.SumTotal = res.data.pager.Total

              //回收的数量
              this.SumTotalPrice(res.data.pager.Total);

              this.Total = res.data.pager.Total;
            });
        });
    },
    //今日回收的数据
    getToDayData() {
      this.axios
        .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
          env: `${this.userData.env}`,
          query: `db.collection("take_back").where({reviewdate:"${this.date}"}).limit(1000).get()`,
        })
        .then((res) => {
          res.data.data.forEach((element, index, array) => {
            array[index] = JSON.parse(element);
          });

          this.TodayTotal = res.data.pager.Total;

          //今日回收的总金额
          let str = "";
          for (let i in res.data.data) {
            str += res.data.data[i].tabs_is;
            str += "+";
          }
          str = str.substring(0, str.length - 1);

          this.TodayPrice = eval(str) || 0;
        });
    },

    // 计算总金额
    SumTotalPrice(event) {
      let sumprice = [];

      let Total = event / 1000;
      for (let i = 0; i < Total; i++) {
        let ae = i * 1000;
        // console.log(i)
        this.axios
          .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
            env: `${this.userData.env}`,
            query: `db.collection("take_back").where({}).limit(1000).skip(${ae}).get()`,
          })
          .then((res) => {
            res.data.data.forEach((element, index, array) => {
              array[index] = JSON.parse(element);
            });

            //循环计算总金额
            let str = "";
            let strs = "";
            let strt = "";

            for (let i in res.data.data) {
              //第一栏金额
              str += res.data.data[i].tabs_is;
              str += "+";

              //第二栏金额 （如有）
              strs +=
                res.data.data[i].tabs_isa !== undefined
                  ? res.data.data[i].tabs_isa !== ""
                    ? res.data.data[i].tabs_isa
                    : 0
                  : 0;
              strs += "+";

              //第三栏金额（如有）

              strt +=
                res.data.data[i].tabs_isaa !== undefined
                  ? res.data.data[i].tabs_isaa !== ""
                    ? res.data.data[i].tabs_isaa
                    : 0
                  : 0;
              strt += "+";
            }
            str = str.substring(0, str.length - 1);
            strs = strs.substring(0, strs.length - 1);
            strt = strt.substring(0, strt.length - 1);

            let Sum2 = eval(strs);
            let Sum3 = eval(strt);
            let Sum = eval(str);

            sumprice.push(Sum, Sum2, Sum3);

            let ae = 0;
            for (let x in sumprice) {
              ae += sumprice[x];
            }

            this.sumPrice = ae;
          });
      }
    },

    //页码改变事件
    Current(event) {
      console.log(event);
      // let ae = event - 1;
      // let pags = ae * 100;
      // let ae = event - 1;
      let pags = event * 100;
      let newPag = this.SumTotal - pags;

      this.axios
        .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
          env: `${this.userData.env}`,
          query: `db.collection("take_back").where({}).limit(100).skip(${newPag}).get()`,
        })
        .then((res) => {
          res.data.data.forEach((element, index, array) => {
            array[index] = JSON.parse(element);
          });
          this.tableData = res.data.data.reverse();
        });
    },
    //查找
    Query(event, Type) {
      // console.log(event)
      if (event !== "") {
        //输入框的名字不为空
        this.axios
          .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
            env: `${this.userData.env}`,
            query: `db.collection("take_back").where({${Type}:"${event}"}).limit(1000).get()`,
          })
          .then((res) => {
            res.data.data.forEach((element, index, array) => {
              array[index] = JSON.parse(element);
            });
            if (res.data.data.length == 0) {
              //没有查找到数据
              return this.$alert(`没有查询到${event}的回收业务，`, "查询结果", {
                confirmButtonText: "确定",
              });
            }
            //查找到了数据返回到列表
            this.tableData = res.data.data;

            this.Total = res.data.pager.Total;
          });
      } else {
        this.$message({
          message: "^_^系统无法知道你脑海想搜索什么，请填写内容后再搜索吧！！",
          type: "warning",
        });
      }
    },
    //日期查找
    QueryDate(event) {
      console.log(event, event[0]);
      if (event !== "") {
        //发送请求

        this.axios
          .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
            env: `${this.userData.env}`,
            query: `db.collection("take_back").where({reviewdate:_.gte("${event[0]}").and(_.lte("${event[1]}"))}).limit(1000).get()`,
          })
          .then((res) => {
            res.data.data.forEach((element, index, array) => {
              array[index] = JSON.parse(element);
            });
            // //请求回来的总数量
            //  for(let i=0;i< res.data.pager.Total;i++){
            //    console
            //  }

            // console.log(res.data)
            //查找到了数据返回到列表
            this.tableData = res.data.data;

            this.Total = res.data.pager.Total;
          });

        this.Showpagination = false;
      } else {
        this.$message({
          message: "^_^请选择日期在搜索吧！！",
          type: "warning",
        });
      }
    },

    //打票
    handleClick(event) {
      this.dialogFormVisible1 = !this.dialogFormVisible1;
      console.log(event);

      this.xudata = event;
    },

    //打印告知书
    PrintClick(event) {
      console.log(event);
      this.NewDatas = event;
      this.PrintTextDiglog = true;
    },
    PrintTextDiglogClose() {
      this.PrintTextDiglog = false;
    },
  },
  created() {
    //获取到this.ACCESS_TOKEN
    this.getTokens();

    //获取当前登录的用户数据
    this.getUserToken();

    //获取今日的日期
    this.date = dayjs().format("YYYY-MM-DD");
  },
  mounted() {
    // console.log('我先执行了')
    setTimeout(() => {
      //请求全部回收数据
      this.getData();
      //请求今日数据
      this.getToDayData();
    }, 800);
  },
};
</script>
<style scoped>
/* X轴，水平左右两边，垂直居中 */
.flex_around {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
}
.flex_around_input {
  margin: 40px 0;
}
.search_input {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.header {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.header_search {
  width: 59%;
  height: 180px;
  background-color: #ffffff;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
.header_info {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  width: 39%;
  height: 180px;
  background-color: #ffffff;
}
.header_info div {
  width: 40%;
  height: 100px;
  background-color: #237912;
  border-radius: 10px;
  color: #ffffff;
  font-size: 25px;
  font-weight: bolder;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.sumTotal {
  font-size: 18px;
}
.search {
  width: 70%;
  margin: 0 auto;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
}
.contents {
  margin: 20px 0;
}

.pagination {
  display: flex;
  flex-direction: row;
  justify-content: center;
}
</style>
